import { motion } from "framer-motion";
import { observer } from "mobx-react-lite";
import type { RefObject } from "react";

import type { ChatInputRef } from "./ChatInput";
import { CHAT_BODY_FADE_TRANSITION } from "./constants";
import { getVibeChatBodyState, VibeChatBodyContent } from "./VibeChatBodyContent";
import type { VibeChatStore } from "./stores";

interface VibeChatBodyProps {
  chatStore: VibeChatStore;
  chatInputRef: RefObject<ChatInputRef>;
  inputValue: string;
  setInputValue: (value: string) => void;
  onSubmit: (message: string) => void;
  handleStop: () => void;
  handleRetry: (messageIndex?: number) => void;
  isLoadingChat: boolean;
}

export const VibeChatBody = observer(
  ({
    chatStore,
    chatInputRef,
    inputValue,
    setInputValue,
    onSubmit,
    handleStop,
    handleRetry,
    isLoadingChat,
  }: VibeChatBodyProps) => {
    const bodyState = getVibeChatBodyState({
      hasMessages: chatStore.messages.length > 0,
      isLoading: chatStore.isLoading,
      isLoadingChat,
    });

    return (
      <motion.div
        className="flex min-h-0 flex-1 flex-col"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={CHAT_BODY_FADE_TRANSITION}
      >
        <VibeChatBodyContent
          bodyState={bodyState}
          chatStore={chatStore}
          chatInputRef={chatInputRef}
          inputValue={inputValue}
          setInputValue={setInputValue}
          onSubmit={onSubmit}
          handleStop={handleStop}
          handleRetry={handleRetry}
        />
      </motion.div>
    );
  },
);
